import {
  ROLE_USER,
  TOKEN_ROLE_APP,
  TOKEN_USERNAME_APP,
} from "./constDispatch";

const ADMIN_OPER = [ROLE_USER.ADMIN, ROLE_USER.OPERATOR];

// Mirrors the owner check on PUT /api/booking/:id — admin and operator edit
// anything, everyone else only what they created. Kept in sync deliberately: if
// the UI is more permissive than the backend, the user types a full edit and
// only finds out it was rejected when they hit save.
export function canEditBooking(booking, username, role) {
  // Nothing loaded yet — there is nothing to save, whatever the role.
  if (booking == null) return false;
  if (username == null || username === "") return false;

  if (role == null || role === "") return false;
  const role_num = Number(role);
  // sessionStorage hands roles back as strings; anything unparseable is not a
  // role we can reason about, so refuse rather than guess.
  if (Number.isNaN(role_num)) return false;

  if (ADMIN_OPER.includes(role_num)) return true;

  // The backend compares with `!=`, so an absent created_by never matches a
  // username and comes back 403. Legacy bookings land here.
  return booking.created_by != null && booking.created_by === username;
}

export function canEditCurrentBooking(booking) {
  return canEditBooking(
    booking,
    sessionStorage.getItem(TOKEN_USERNAME_APP),
    sessionStorage.getItem(TOKEN_ROLE_APP)
  );
}
